var default_styles_default = {
  "button_container": "wNg-v",
  "button_margin": "fB6ss",
  "button_text": "ZKt-d",
  "button_size_content": "CgRin"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
